var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.64 38.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e03616;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.63,5.88c.67-.67,1.01-1.43,1.01-2.44,0-.92-.34-1.76-1.01-2.44-.67-.67-1.43-1.01-2.44-1.01-.92,0-1.76,.34-2.44,1.01l-13.44,13.44L5.88,1.01c-.67-.67-1.43-1.01-2.44-1.01-.92,0-1.76,.34-2.44,1.01C.34,1.68,0,2.52,0,3.44s.34,1.76,1.01,2.44l13.44,13.44L1.01,32.76c-.67,.67-1.01,1.51-1.01,2.44s.34,1.76,1.01,2.44c.67,.67,1.51,1.01,2.44,1.01s1.76-.34,2.44-1.01l13.44-13.44,13.44,13.44c.67,.67,1.51,1.01,2.44,1.01s1.76-.34,2.44-1.01c.67-.67,1.01-1.43,1.01-2.44,0-.92-.34-1.76-1.01-2.44l-13.44-13.44,13.44-13.44Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.07b777d2be9afbf3cbe4d88dc47f3be6.svg";
export { ForwardRef as ReactComponent };